// extracted by mini-css-extract-plugin
export var cards = "DownloadsPage-module--cards--MFoAM";
export var singleCard = "DownloadsPage-module--singleCard--C13hV";
export var supportCard = "DownloadsPage-module--supportCard--unojP";
export var textContainer = "DownloadsPage-module--textContainer--z5qLf";
export var paragraph = "DownloadsPage-module--paragraph--FutQr";